import { render, staticRenderFns } from "./bfm-form.vue?vue&type=template&id=45bec842&scoped=true&"
import script from "./bfm-form.vue?vue&type=script&lang=js&"
export * from "./bfm-form.vue?vue&type=script&lang=js&"
import style0 from "./bfm-form.vue?vue&type=style&index=0&id=45bec842&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bec842",
  null
  
)

export default component.exports